var render = function render(){var _vm=this,_c=_vm._self._c;return _c('new-tree',{ref:"tree",attrs:{"node-key":"id","props":_vm.treeProps,"data":_vm.treeData,"lazy":"","expand-on-click-node":false,"load":_vm.loadNode,"default-expanded-keys":[_vm.rootNode.id],"current-node-key":_vm.rootNode.id},on:{"node-click":_vm.handleNodeClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }